'use client';
/* Built In Imports */
import dynamic from 'next/dynamic';

/* External Imports */
import { Box, Button, Image, Text, useBreakpointValue } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
const ReactPlayer = dynamic(() => import('react-player'));

/* Internal Imports */
// Components
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';
/**
 *
 * @param {Object} sectionContent
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const Workshops = ({ sectionContent, region, lang }) => {
  const titleSection = sectionContent.find(
    item => item._modelApiKey === 'section_title'
  );
  const buttonSection = sectionContent.find(
    item => item._modelApiKey === 'simple_button'
  );
  const deskVideo = sectionContent.find(item => item.fieldId === 'desk-video');

  const mobVideo = sectionContent.find(item => item.fieldId === 'mob-video');

  const titleText = titleSection?.titleText || 'Default Title';
  const buttonText = buttonSection?.buttonText || 'Default Button Text';
  const buttonLink = buttonSection?.linkUrl || '#';

  const isLg = useBreakpointValue({ base: false, lg: true });
  // console.log('isLg', sectionContent);
  return (
    <>
      {/* main container */}
      <Box
        pt={{
          '2xl': '22rem',
          xl: '15rem',
          lg: '22rem',
          md: '12rem',
          base: '10rem',
        }}
        position="relative"
      >
        {/* Image in top-right corner */}
        {/* adjust position according to layout */}
        <Box
          position="absolute"
          top={{ '2xl': '-0.1875rem', lg: '0', md: '6%', base: '4%' }}
          right={{ base: '3%', lg: '11rem' }}
          width={{ base: '4.5rem', md: '106px', lg: '150px', '2xl': '160px' }}
          height={{ base: '189px', md: '292px', lg: '400px', '2xl': '442px' }}
          m="10px"
          mixBlendMode={'multiply'}
        >
          <Image
            src={`${config.imgPath}/d/46272/1720008464-kolam-programs.png`}
            alt="Top Right Image"
            width="100%"
            height="100%"
            objectFit="cover"
          />
        </Box>

        {/* box contain all this text */}
        <Box
          mx={{ base: '16px', lg: 'auto' }}
          maxWidth={{ lg: '70%' }}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          {/* box for heading */}
          <Box
            textAlign="center"
            as="h1"
            color="#EDA807"
            fontSize={{
              base: '1.75rem',
              md: '36px',
              lg: '2.625rem',
              '2xl': '52px',
            }}
            fontFamily="var(--FedraSerifDisplay-Bold)"
            // fontWeight="700"
            letterSpacing="1%"
            lineHeight={{ base: '33.6px', md: '43.2px', lg: '50.4px' }}
            mb={{ base: '24px' }}
          >
            {titleText}
          </Box>

          <Box
            width={{ base: '100%', md: '88%', lg: '42rem', '2xl': '46rem' }}
            mx="auto"
            marginBottom={{ md: '5rem', lg: '0' }}
            paddingX={{ md: '5rem', lg: '1rem' }}
            padding={{ base: '.5rem' }}
            css={{
              '@media (min-width: 62em)': {
                '& p': {
                  marginBottom: '-1rem', // Add margin to each paragraph from md and up
                },
              },
            }}
          >
            <StructuredTextParser
              str={render(sectionContent[1]?.body)}
              textAlign="center"
              as="p"
              color="#FFFFFF"
              fontWeight="400"
              fontSize={{ base: '0.875rem', md: '.875rem', lg: '1.25rem' }}
              lineHeight={{ base: '22.4px', lg: '28.8px', '2xl': '2rem' }}
              letterSpacing="2%"
              fontFamily="var(--FedraSansStd-book)"
            />
          </Box>

          {/* Image and Button */}
          {isLg ? (
            <>
              <Button
                as="a"
                href={refineUrlDomain(buttonLink, region, lang)}
                width={{ lg: '250px', base: '328px' }}
                maxW="95%"
                target={buttonSection?.openInNewTab ? '_blank' : '_self'}
                bgColor="#EDA807"
                border="none"
                letterSpacing={{ base: '4%', md: '2%' }}
                lineHeight={{ base: '25.6px', lg: '22.5px' }}
                fontSize={{ base: '1rem', lg: '1.125rem' }}
                height={{ lg: '57px', base: '50px' }}
                borderRadius="none"
                mt={{ base: '4rem' }}
                // px={{ md: '3rem', base: '6rem' ,lg:"3.5rem"}}
                // py={"2rem"}
                _hover={{ bgColor: '#F2C251' }}
              >
                <Text
                  color="#010509"
                  fontFamily="var(--FedraSansStd-medium)"
                  fontWeight={{ base: '500', md: '700' }}
                  fontSize={{ base: '16px', md: '18px' }}
                  lineHeight={{ base: '25.6px', md: '22.5px' }}
                  letterSpacing={{ base: '0.32px', md: '0.64px' }}
                >
                  {buttonText}
                </Text>
              </Button>

              <Box
                position="relative"
                width="100vw"
                left={{ base: '52%', lg: '71.4%' }}
                transform="translateX(-50%)"
                overflowX="hidden"
                mt={{ lg: '24px', xl: '18%', '2xl': '24px' }}
              >
                {deskVideo && (
                  <ReactPlayer
                    url={deskVideo?.text}
                    playing={true}
                    controls={false}
                    muted={true}
                    loop={true}
                    width="100%"
                    autoPlay={true}
                    height="100%"
                    objectFit="cover"
                  />
                )}
              </Box>
            </>
          ) : (
            <>
              <Box
                position="relative"
                width="100vw"
                left={{ base: '52%', lg: '71.4%' }}
                transform="translateX(-50%)"
                overflowX="hidden"
                mt={{ lg: '24px' }}
              >
                {mobVideo && (
                  <ReactPlayer
                    url={mobVideo?.text}
                    playing={true}
                    controls={false}
                    muted={true}
                    loop={true}
                    width="100%"
                    autoPlay={true}
                    height="100%"
                    objectFit="cover"
                  />
                )}
              </Box>

              <Button
                as="a"
                href={refineUrlDomain(buttonLink, region, lang)}
                target={buttonSection?.openInNewTab ? '_blank' : '_self'}
                bgColor="#EDA807"
                border="none"
                display={{ base: 'flex', lg: 'none' }}
                width={{ base: '100%', md: '201px' }}
                height={{ base: '50px' }}
                color="#010509"
                borderRadius="none"
                mt={{ base: '48px' }}
                // py={{lg:"2rem"}}
                py={{ base: '12px' }}
                px={{ base: '2rem', md: '3rem' }}
                _hover={{ bgColor: '#ffba00' }}
              >
                <Text
                  color="#010509"
                  fontFamily="var(--FedraSansStd-medium)"
                  fontWeight="700"
                >
                  {buttonText}
                </Text>
              </Button>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Workshops;
